<div fxLayout="column" fxLayoutGap="0.5erm" class="mat-typography">
  <h2 mat-dialog-title>{{ title | translate | uppercase }}</h2>
  <mat-dialog-content>
    {{ message | translate | uppercase }}
  </mat-dialog-content>
  <br>
</div>
